/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  // Microsoft Clarity now loads from the <head> of layout/theme.liquid
  // (moved 2026-09-29 so it starts before quick visitors leave).


  // bookthatapp calendar tracking code
window.addEventListener('load', function () {
    var hasCalendarBeenInteracted = false;
    var isCalendarVisible = false;
    var isProjectOptionsVisible = false;
    var hasCheckoutBeenClicked = false;
    var iframe = document.querySelector('div#bta-widget-container > div > iframe[title="widget_xcomponent"]');

    if (iframe) {
        var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

        // Track first interaction inside the calendar iframe
        iframeDocument.addEventListener('click', function (event) {
            if (!hasCalendarBeenInteracted) {
                dataLayer.push({
                    event: 'calendar_interaction'
                });
                hasCalendarBeenInteracted = true;
            }
        });

        // Track calendar (date picker) visibility
        var calendar = iframeDocument.querySelector('.date-picker-container');
        if (calendar) {
            var calendarObserver = new iframe.contentWindow.IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting && !isCalendarVisible) {
                        dataLayer.push({
                            event: 'calendar_visible'
                        });
                        isCalendarVisible = true;
                        calendarObserver.disconnect();
                    }
                });
            }, {
                root: iframeDocument,
                threshold: 0.1
            });

            calendarObserver.observe(calendar);
        }

        // Track project options visibility
        var checkProjects = setInterval(function () {
            var projectContainer = iframeDocument.querySelector('.variants-container');
            if (projectContainer) {
                clearInterval(checkProjects);

                var projectObserver = new iframe.contentWindow.IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting && !isProjectOptionsVisible) {
                            dataLayer.push({
                                event: 'project_options_visible'
                            });
                            isProjectOptionsVisible = true;
                            projectObserver.disconnect();
                        }
                    });
                }, {
                    root: iframeDocument,
                    threshold: 0.1
                });

                projectObserver.observe(projectContainer);
            }

            // Track Checkout button click — only the real one
            var buttons = iframeDocument.querySelectorAll('button[data-type="submit"]');
            buttons.forEach(function (btn) {
                if (btn.textContent.trim().toLowerCase() === 'checkout') {
                    btn.addEventListener('click', function () {
                        if (!hasCheckoutBeenClicked) {
                            dataLayer.push({
                                event: 'checkout_clicked'
                            });
                            hasCheckoutBeenClicked = true;
                        }
                    });
                }
            });
        }, 500);
    }
});







  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
